export default "__VITE_ASSET__B_49Nedy__"